const OPTION_DESIGN_PRIZE_FORM_B = {
    listSortDirection: [
        {
            id: 1,
            label: '横並び',
            value: 'horizontal'
        },
        {
            id: 2,
            label: '縦並び',
            value: 'vertical'
        }
    ],

    listSortArrangement: [
        {
            id: 1,
            label: '左寄せ',
            value: 'left'
        },
        {
            id: 2,
            label: '中央寄せ',
            value: 'center'
        },
        {
            id: 3,
            label: '右寄せ',
            value: 'right'
        }
    ]
};

const configLayoutPrize = () => {
    return {
        direction: {
            trackBy: 'id',
            label: 'label',
            errorText: '',
            error: false,
            isRemove: true,
            typesValidate: []
        },
        arrangement: {
            trackBy: 'id',
            label: 'label',
            errorText: '',
            error: false,
            isRemove: true,
            typesValidate: []
        }
    };
};

export { OPTION_DESIGN_PRIZE_FORM_B, configLayoutPrize };
